import { useLocalStorage } from "react-use";
import { httpsCallable } from 'firebase/functions';
import { useFunctions } from 'reactfire';
import { useState } from "react";
import PulseLoader from "react-spinners/PulseLoader";

export default function Publish(props) {
  const { setPublishCount } = props
  const [, setHasUnpublishedChanges] = useLocalStorage('unpublishedChanges', false)

  const functions = useFunctions();
  const publishFunction = httpsCallable(functions, 'publish');
  const [publishing, setPublishing] = useState(false)
  const [published, setPublished] = useState(false)
  const publishGroves = async () => {
    setPublishing(true)
    await publishFunction();
    setHasUnpublishedChanges(false)
    setPublished(true)
    setPublishCount(d => d + 1)

  }

  return (
    <div className='status unpublished'>
      {published ? 'Changes Published' :
      <>
        You currently have unpublished changes to the grove database.
        {' '}
        {
          publishing ? <PulseLoader size={'0.5em'} color="#14816E" />
          :
          <button onClick={publishGroves} className='button'>Publish</button>
        }
      </>
    }
    </div>
  )
}
